
// Purpose: Show the free standard-shipping threshold for a four-digit postcode
// in the Bonza cart drawer. This does not calculate cart spend or change rates.
//
// Keep these ranges aligned with the rural postcode rules in Kivaro.
// Single postcodes and inclusive ranges are both supported.
const bonzaRuralPostcodes = `
2265,2311-2312,2321,2323,2326-2334,2336-2347,2350-2361,2365,2369-2372,2379-2382,2386-2390,2395-2431,2439-2441,2443-2449,2453,2460-2484,2489,2535-2551,2575-2581,2583-2594,2621-2633,2642-2647,2649,2651-2678,2700-2703,2706-2707,2710-2714,2716,2720-2730,2787-2799,2803-2810,2817-2849,2852,2864-2879,
2648,2715,2717,2731-2739,3231-3243,3249-3254,3260-3294,3300-3330,3332-3334,3342-3345,3351-3352,3358-3364,3370-3402,3407-3424,3444-3451,3460-3462,3464-3494,3501-3502,3506-3512,3516-3522,3525-3533,3537-3549,3552-3554,3558-3599,3607-3624,3632-3649,3658-3688,3691-3749,3812-3825,3831-3835,3840-3904,3909,3921-3925,3945-3946,3950-3971,3979,3984,3987-3996,
4309-4314,4340-4342,4352-4365,4370-4374,4377-4378,4382-4390,4401-4428,4580-4581,4600-4601,4605-4615,4620-4630,4650,4659-4662,4670-4680,4454-4455,4461-4498,4694-4699,4702,4704-4739,4741-4746,4753-4757,4798-4802,4804-4805,4803,4806-4809,4813,4816,4819-4830,4849-4865,4871-4877,4880-4895,
2880,5202-5204,5210-5214,5220-5223,5231-5244,5250-5280,5290-5311,5320-5322,5330-5333,5340-5346,5350,5353-5354,5356-5357,5360,5371-5374,5381,5400-5401,5410-5422,5431-5434,5440,5451-5455,5460-5464,5470-5473,5480-5485,5490-5495,5501-5502,5510,5520-5523,5540,5550-5560,5570-5583,5600-5611,5630-5633,5640-5642,5650-5655,5660-5661,5670-5671,5680,5690,5700-5701,5710-5725,5730-5734,
6215-6244,6251-6262,6271-6284,6286-6290,6302-6375,6383-6386,6390-6452,6460-6490,6502-6537,6556-6575,6603-6616,6620-6646,6701-6733,6740-6743,6751-6765,6770,
0803,0815,0822,0832-0841,0845-0850,0852-0854,0860,0862,0870,0872-0875,0880-0881,0885-0886,
2898-2899,6798-6799,7151
`;

// Parse the list once. Number conversion is only for comparison;
// the customer's entered postcode remains a four-character string.
const bonzaRuralRanges = bonzaRuralPostcodes
  .split(',')
  .map((entry) => entry.trim())
  .filter(Boolean)
  .map((entry) => {
    const [start, end = start] = entry.split('-').map(Number);
    return [start, end];
  });

function bonzaCheckPostcode(checker) {
  const input = checker.querySelector('[data-bonza-postcode-input]');
  const result = checker.querySelector('[data-bonza-postcode-result]');
  const postcode = input.value.trim();

  if (!/^\d{4}$/.test(postcode)) {
    result.textContent = 'Please enter a four-digit postcode.';
    return;
  }

  const postcodeNumber = Number(postcode);
  const isRural = bonzaRuralRanges.some(
    ([start, end]) => postcodeNumber >= start && postcodeNumber <= end
  );

  result.textContent = isRural
    ? `Postcode ${postcode}: free standard shipping on orders over $250. Confirmed at checkout.`
    : `Postcode ${postcode}: free standard shipping on orders over $165. Confirmed at checkout.`;
}

// Impulse can replace the drawer markup after cart updates. Delegating these
// events to document means the new input and button continue to work.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest('[data-bonza-postcode-button]');
  if (!button) return;

  const checker = button.closest('[data-bonza-postcode-check]');
  if (checker) bonzaCheckPostcode(checker);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || !(event.target instanceof Element)) return;
  if (!event.target.matches('[data-bonza-postcode-input]')) return;

  // The drawer input sits inside the cart form: Enter must not check out.
  event.preventDefault();

  const checker = event.target.closest('[data-bonza-postcode-check]');
  if (checker) bonzaCheckPostcode(checker);
});
